export default __webpack_public_path__ + "static/media/Play button.f431a0ab.svg";